const projectsData = [
  {
    title: "E-Commerce Application: SpringBoot Angular  ",
    image: "./p7.png",
    description:
      "An ecommerce application developed using react , node , redux and mongodb",
    link: "https://ecommerce-spring-angular.netlify.app",
  },
  {
    title: "CareMonitorAI: Post-Discharge Patient Support",
    image: "./p1.png",
    description:
      "A modern web app with AI to help nurse practitioners to monitor patients during the first weeks of their release from the hospital and also help the patients to monitor their daily activities that implemented using React, Node, Redux, MongoDB and TensorFlow.",
    link: "https://health-risk-ai.netlify.app/",
  },
  {
    title: "AI: Image Detection",
    image: "./p2.jpeg",
    description:
      "An interactive web application built with TensorFlow.js and ReactJS that allows users to upload images from their local computer or via a URL for real-time object detection.",
    link: "https://sorada-prathan-image-identification.netlify.app/",
  },
  {
    title: "Cloud-Based Movie Review Platform",
    image: "./p3.jpg",
    description:
      "A .NET-based cloud application designed for movie reviews, leveraging AWS services including S3 for efficient data storage and DynamoDB for scalable database management. Explore the project on GitHub to see its implementation and features in action",
    link: "https://github.com/sorada1111/MovieReviewAWS.git",
  },
  {
    title: "Toronto Real Estate API on Cloud",
    image: "./p4.png",
    description:
      "A Real Estate API application developed using .NET technologies , S3 and DynamoDB on AWS cloud.",
    link: "https://github.com/sorada1111/TorontoRealEstateAPI.git",
  },
  {
    title: "AWS S3 Service",
    image: "./p5.png",
    description:
      "An AWS S3 Service application developed using c# , WPF , and S3 on AWS cloud.",
    link: "https://github.com/sorada1111/COMP306_Lab1_AWSS3service.git",
  },
];

export default projectsData;
